import { render } from "./QuizTakeView.vue?vue&type=template&id=1b4468b5"
import script from "./QuizTakeView.vue?vue&type=script&lang=js"
export * from "./QuizTakeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__